import React from 'react';

export const FooterBar: React.FC = () => {
  return (
    <footer
      className="mt-8 px-4 sm:px-8 py-6"
      style={{
        background: 'rgba(15, 17, 20, 0.9)',
        borderTop: '1px solid rgba(255, 255, 255, 0.08)',
      }}
    >
      <div className="max-w-5xl mx-auto flex flex-col gap-3 text-sm text-gray-200 leading-relaxed">
        <div className="font-semibold text-white">About Us</div>
        <div className="grid sm:grid-cols-2 gap-2">
          <div>Reniel Galang — Project Lead</div>
          <div>Medwin Avelino — Documentation Lead</div>
          <div>John Lloyd Cadang — Lead Developer & Designer</div>
          <div>Justin Mina — Assistant Hardware Developer</div>
          <div>Ivan Kier Mananquil — Lead Hardware Developer</div>
        </div>
        <div className="text-gray-400">
          This project is for educational purposes only and is not intended for production use or reuse.
        </div>
      </div>
    </footer>
  );
};






